'use client';

import { c as _c } from "react/compiler-runtime";
import Link from 'next/link';
import { BrandLogo } from '@/components/brand/BrandLogo';
import { CadrinoHrLogo } from '@/components/brand/CadrinoHrLogo';
import { BRAND_LOGO_HEIGHT } from '@/lib/brand/brand-assets';
import { useCadrinoCopy } from '@/lib/cadrino-landing/useCadrinoCopy';
import { useWebsitePagesCopy } from '@/lib/cadrino-landing/useWebsitePagesCopy';
import { Container } from './shared';
export function CadrinoFooter() {
  const $ = _c(56);
  const c = useCadrinoCopy();
  const pages = useWebsitePagesCopy();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = new Date().getFullYear();
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  const year = t0;
  let t1;
  if ($[1] !== pages.nav.product) {
    t1 = {
      href: "/product",
      label: pages.nav.product
    };
    $[1] = pages.nav.product;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== pages.nav.partners) {
    t2 = {
      href: "/partners",
      label: pages.nav.partners
    };
    $[3] = pages.nav.partners;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  let t3;
  if ($[5] !== pages.nav.security) {
    t3 = {
      href: "/security",
      label: pages.nav.security
    };
    $[5] = pages.nav.security;
    $[6] = t3;
  } else {
    t3 = $[6];
  }
  let t4;
  if ($[7] !== pages.nav.integrations) {
    t4 = {
      href: "/integrations",
      label: pages.nav.integrations
    };
    $[7] = pages.nav.integrations;
    $[8] = t4;
  } else {
    t4 = $[8];
  }
  let t5;
  if ($[9] !== c.nav.contact) {
    t5 = {
      href: "/#contact",
      label: c.nav.contact
    };
    $[9] = c.nav.contact;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  let t6;
  if ($[11] !== t1 || $[12] !== t2 || $[13] !== t3 || $[14] !== t4 || $[15] !== t5) {
    t6 = [t1, t2, t3, t4, t5];
    $[11] = t1;
    $[12] = t2;
    $[13] = t3;
    $[14] = t4;
    $[15] = t5;
    $[16] = t6;
  } else {
    t6 = $[16];
  }
  const links = t6;
  let t7;
  if ($[17] !== pages.nav.privacy) {
    t7 = {
      href: "/privacy",
      label: pages.nav.privacy
    };
    $[17] = pages.nav.privacy;
    $[18] = t7;
  } else {
    t7 = $[18];
  }
  let t8;
  if ($[19] !== pages.nav.terms) {
    t8 = {
      href: "/terms",
      label: pages.nav.terms
    };
    $[19] = pages.nav.terms;
    $[20] = t8;
  } else {
    t8 = $[20];
  }
  let t9;
  if ($[21] !== t7 || $[22] !== t8) {
    t9 = [t7, t8];
    $[21] = t7;
    $[22] = t8;
    $[23] = t9;
  } else {
    t9 = $[23];
  }
  const legalLinks = t9;
  let t10;
  if ($[24] !== c.footer.tagline) {
    t10 = <p className="mt-2 text-sm text-cadrino-muted leading-relaxed">{c.footer.tagline}</p>;
    $[24] = c.footer.tagline;
    $[25] = t10;
  } else {
    t10 = $[25];
  }
  let t11;
  if ($[26] !== c.footer.ecosystem) {
    t11 = <p className="mt-3 text-sm text-cadrino-muted leading-relaxed">{c.footer.ecosystem}</p>;
    $[26] = c.footer.ecosystem;
    $[27] = t11;
  } else {
    t11 = $[27];
  }
  let t12;
  if ($[28] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = <BrandLogo href="/" variant="forLightBg" height={22} />;
    $[28] = t12;
  } else {
    t12 = $[28];
  }
  let t13;
  if ($[29] === Symbol.for("react.memo_cache_sentinel")) {
    t13 = <div className="mt-5 flex items-center gap-3 md:mt-auto">{t12}<a href="https://cadrinohr.com" target="_blank" rel="noopener noreferrer" className="inline-flex items-center"><CadrinoHrLogo variant="forLightBg" height={20} /></a></div>;
    $[29] = t13;
  } else {
    t13 = $[29];
  }
  let t14;
  if ($[30] !== t10 || $[31] !== t11) {
    t14 = <div className="flex h-full flex-col">{t10}{t11}{t13}</div>;
    $[30] = t10;
    $[31] = t11;
    $[32] = t14;
  } else {
    t14 = $[32];
  }
  let t15;
  if ($[33] !== links) {
    t15 = <div><ul className="space-y-3 text-sm text-cadrino-muted">{links.map(_temp)}</ul></div>;
    $[33] = links;
    $[34] = t15;
  } else {
    t15 = $[34];
  }
  let t16;
  if ($[35] !== legalLinks) {
    t16 = legalLinks.map(_temp2);
    $[35] = legalLinks;
    $[36] = t16;
  } else {
    t16 = $[36];
  }
  let t17;
  if ($[37] !== c.nav.signIn) {
    t17 = <li><Link href="/login" className="hover:text-slate-800 transition-colors">{c.nav.signIn}</Link></li>;
    $[37] = c.nav.signIn;
    $[38] = t17;
  } else {
    t17 = $[38];
  }
  let t18;
  if ($[39] !== t16 || $[40] !== t17) {
    t18 = <div><ul className="space-y-3 text-sm text-cadrino-muted">{t16}{t17}</ul></div>;
    $[39] = t16;
    $[40] = t17;
    $[41] = t18;
  } else {
    t18 = $[41];
  }
  const t19 = `mailto:${c.footer.sales}`;
  let t20;
  if ($[42] !== c.footer.sales || $[43] !== t19) {
    t20 = <a href={t19} className="text-sm text-cadrino-muted hover:text-slate-800 transition-colors">{c.footer.sales}</a>;
    $[42] = c.footer.sales;
    $[43] = t19;
    $[44] = t20;
  } else {
    t20 = $[44];
  }
  let t21;
  if ($[45] !== c.brand || $[46] !== c.footer.rights) {
    t21 = <div className="mt-5 text-xs text-cadrino-muted md:mt-auto">© {year} {c.brand}. {c.footer.rights}</div>;
    $[45] = c.brand;
    $[46] = c.footer.rights;
    $[47] = t21;
  } else {
    t21 = $[47];
  }
  let t22;
  if ($[48] !== t20 || $[49] !== t21) {
    t22 = <div className="flex h-full flex-col md:items-end md:text-right">{t20}{t21}</div>;
    $[48] = t20;
    $[49] = t21;
    $[50] = t22;
  } else {
    t22 = $[50];
  }
  let t23;
  if ($[51] !== t14 || $[52] !== t15 || $[53] !== t18 || $[54] !== t22) {
    t23 = <footer className="border-t border-slate-200 bg-cadrino-bg/50"><Container className="py-16"><div className="grid gap-10 md:grid-cols-4 md:items-stretch">{t14}{t15}{t18}{t22}</div></Container></footer>;
    $[51] = t14;
    $[52] = t15;
    $[53] = t18;
    $[54] = t22;
    $[55] = t23;
  } else {
    t23 = $[55];
  }
  return t23;
}
function _temp2(link_0) {
  return <li key={link_0.href}><Link href={link_0.href} className="hover:text-slate-800 transition-colors">{link_0.label}</Link></li>;
}
function _temp(link) {
  return <li key={link.href}><Link href={link.href} className="hover:text-slate-800 transition-colors">{link.label}</Link></li>;
}